/* eslint-disable no-undef */
import axios from 'axios';
import global_ from '~/components/Global.vue';
import store from '~/store';
import router from '~/router';
import { Message } from 'element-ui';
import Cookies from 'js-cookie';

axios.defaults.baseURL = process.env.BASE_API;
axios.defaults.timeout = 60000;

export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data);
    });
  });
}

export function post(url, params, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, headers)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

axios.interceptors.request.use(
  config => {
    let token = '';
    if(Cookies.get('Token')){
      token = Cookies.get('Token');
    }
    if (!token && store.getters.token) {
      token = store.getters.token;
    }
    config.params = {
      token: token
    };
    return config;
  },
  err => {
    return Promise.reject(err);
  });

// http response 拦截器
axios.interceptors.response.use(
  response => {
    let errcode = response.data.errcode;
    let path = '';
    let toastMsg = '';
    switch (errcode) {
    case global_.ERRCODE.TokenMissing:
      path = '/';
      toastMsg = '登录信息丢失，请重新登录';
      store.dispatch('Logout');
      break;
    case global_.ERRCODE.TokenError:
      path = '/';
      toastMsg = '登录信息丢失，请重新登录';
      store.dispatch('Logout');
      break;
    case global_.ERRCODE.NotFoundLicence:
      path = '/UploadLicence';
      toastMsg = '缺少营业执照，请上传';
      break;
    case global_.ERRCODE.HrNotAudit:
      path = '/VerifyWait';
      toastMsg = '正在审核中，请耐心等待';
      break;
    case global_.ERRCODE.CompanyVerifyFail:
      path = '/VerifyFail';
      toastMsg = '审核失败，请查看原因，如还有疑问请联系顾问';
      break;
    }

    if (path) {
      redirectPath(toastMsg, path);
    }
    return response;
  },
  error => {
    // eslint-disable-next-line no-console
    console.log('err' + error); // for debug    
    return Promise.reject(error);
  });

const redirectPath = (toastMsg, path) => {     
  if(toastMsg){
    Message.error(toastMsg);
  }  
  if(path){
    if(router.path == path){
      router.go(0);
    } else {
      router.replace({
        path: path
      });
    }
  }
};
  
export default axios;